export default __webpack_public_path__ + "static/index-title-feature-zh-Hant-50d1b6c5ef97410573906f50bc1134f1.png";